module.exports = __webpack_public_path__ + "static/media/seguros-mundial-minus.28610c56.svg";